import src from "IMAGE";
export default { src, width: 570, height: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAIAAABsYngUAAAADklEQVR42mO49/QtVgQADHAVgUxllewAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 1 }
